import _ from 'lodash';
import { generateVisPropWithColumnSettings, sanitizeCustomVisualProps, } from '../form-builder.util';
import { isPropElement } from './custom-chart-schema-hydrator.util';
import { getElementValue, sanitizeCustomVisualPropsV2 } from './helpers';
export const generateVisualPropsFromElements = (elements) => {
    const visualProps = {};
    elements.forEach(element => {
        if (isPropElement(element)) {
            if (element.type === 'customsort') {
                return;
            }
            if (element.type === 'section') {
                _.set(visualProps, element.key, generateVisualPropsFromElements(element.children));
            }
            else {
                _.set(visualProps, element.key, getElementValue(element));
            }
        }
        else if (element?.children && element?.children.length) {
            if (element.key && !element.isAnswerProperty) {
                const childProps = generateVisualPropsFromElements(element.children);
                const ownValue = getElementValue(element);
                _.set(visualProps, element.key, ownValue && typeof ownValue === 'object'
                    ? { ...ownValue, ...childProps }
                    : childProps);
            }
            else {
                const childrenVisualProps = generateVisualPropsFromElements(element.children);
                _.merge(visualProps, childrenVisualProps);
            }
        }
        else if (element.key && !element.isAnswerProperty) {
            _.set(visualProps, element.key, getElementValue(element));
        }
    });
    return visualProps;
};
export const getAllConditionalFormattingsFromVizProp = (columnProperties) => {
    const allConditionalFormattings = {};
    if (!columnProperties || !Array.isArray(columnProperties)) {
        return allConditionalFormattings;
    }
    columnProperties.forEach(({ columnId, columnProperty }) => {
        const rows = columnProperty?.conditionalFormatting?.rows;
        if (rows && rows.length > 0) {
            allConditionalFormattings[columnId] = rows;
        }
    });
    return allConditionalFormattings;
};
export const getConditionalFormatsFromCustomVisualProps = (customVisualProps, columnId) => {
    const columnProps = customVisualProps?.columnVisualProps?.[columnId];
    return columnProps?.conditionalFormatting?.rows || [];
};
const updateCustomVisualPropsWithConditionalFormats = (customVisualProps, columnId, conditionalFormattings) => {
    const updatedVisualProps = _.cloneDeep(customVisualProps);
    if (!updatedVisualProps.columnVisualProps) {
        updatedVisualProps.columnVisualProps = {};
    }
    if (!updatedVisualProps.columnVisualProps[columnId]) {
        updatedVisualProps.columnVisualProps[columnId] = {};
    }
    if (conditionalFormattings && conditionalFormattings.length > 0) {
        updatedVisualProps.columnVisualProps[columnId].conditionalFormatting = {
            rows: conditionalFormattings,
        };
    }
    else {
        updatedVisualProps.columnVisualProps[columnId].conditionalFormatting = {
            rows: [],
        };
    }
    return updatedVisualProps;
};
export const updateCustomVisualPropsWithAllConditionalFormats = (customVisualProps, allConditionalFormattings) => {
    let updatedVisualProps = { ...customVisualProps };
    if (allConditionalFormattings &&
        Object.keys(allConditionalFormattings).length > 0) {
        Object.entries(allConditionalFormattings).forEach(([columnId, conditionalFormattings]) => {
            updatedVisualProps = updateCustomVisualPropsWithConditionalFormats(updatedVisualProps, columnId, conditionalFormattings);
        });
    }
    else if (updatedVisualProps.columnVisualProps) {
        Object.keys(updatedVisualProps.columnVisualProps).forEach(columnId => {
            if (updatedVisualProps.columnVisualProps[columnId]
                ?.conditionalFormatting) {
                updatedVisualProps = updateCustomVisualPropsWithConditionalFormats(updatedVisualProps, columnId, []);
            }
        });
    }
    return updatedVisualProps;
};
export const generateCustomVisualProps = (visualPropEditorDefinition) => {
    let customVisualProps = {
        columnVisualProps: {},
        axisVisualProps: {},
        dataLabelVisualProps: {},
        tooltipVisualProps: {},
        legendVisualProps: {},
        displayVisualProps: {},
    };
    if (!visualPropEditorDefinition) {
        return customVisualProps;
    }
    const { elements, columnsVizPropDefinition, displayVizPropDefinition, dataLabelVizPropDefinition, tooltipVizPropDefinition, legendVizPropDefinition, axisVizPropDefinition, } = visualPropEditorDefinition;
    if (elements && elements.length) {
        customVisualProps = {
            ...customVisualProps,
            ...generateVisualPropsFromElements(elements),
        };
    }
    if (columnsVizPropDefinition && columnsVizPropDefinition.length) {
        customVisualProps.columnVisualProps = {};
        columnsVizPropDefinition.forEach(item => {
            Object.entries(item.columnSettingsDefinition).forEach(([colId, colDef]) => {
                customVisualProps.columnVisualProps[colId] =
                    generateVisualPropsFromElements(colDef?.elements) || {};
            });
        });
    }
    if (axisVizPropDefinition && axisVizPropDefinition.length) {
        customVisualProps.axisVisualProps =
            generateVisualPropsFromElements(axisVizPropDefinition) || {};
    }
    if (dataLabelVizPropDefinition && dataLabelVizPropDefinition.length) {
        customVisualProps.dataLabelVisualProps =
            generateVisualPropsFromElements(dataLabelVizPropDefinition) || {};
    }
    if (tooltipVizPropDefinition && tooltipVizPropDefinition.length) {
        customVisualProps.tooltipVisualProps =
            generateVisualPropsFromElements(tooltipVizPropDefinition) || {};
    }
    if (legendVizPropDefinition && legendVizPropDefinition.length) {
        customVisualProps.legendVisualProps =
            generateVisualPropsFromElements(legendVizPropDefinition) || {};
    }
    if (displayVizPropDefinition && displayVizPropDefinition.length) {
        customVisualProps.displayVisualProps =
            generateVisualPropsFromElements(displayVizPropDefinition) || {};
    }
    return customVisualProps;
};
export function shouldRenderPropElements(visualPropEditorDefinition) {
    if (visualPropEditorDefinition?.displayVizPropDefinition &&
        visualPropEditorDefinition?.displayVizPropDefinition?.length) {
        return false;
    }
    return true;
}
const getConditionalFormatsFromOverrideColumnProperties = (overrideColumnProperties) => {
    const result = {};
    if (!overrideColumnProperties || !Array.isArray(overrideColumnProperties)) {
        return result;
    }
    overrideColumnProperties.forEach(({ columnId, properties }) => {
        if (columnId && properties?.conditionalFormatting !== undefined) {
            const rows = properties?.conditionalFormatting?.rows;
            result[columnId] = rows;
        }
    });
    return result;
};
export const replaceStaleCFRulesWithLegacy = (customVisualProps, legacyColumnProperties, chartColumns) => {
    const columnVisualProps = customVisualProps?.columnVisualProps;
    if (!columnVisualProps || !chartColumns?.length) {
        return customVisualProps;
    }
    const currentColumnIds = new Set(chartColumns.map(col => col?.id).filter(Boolean));
    const legacyByCurrentId = getAllConditionalFormattingsFromVizProp(legacyColumnProperties || []);
    const hasStaleLhs = (rows) => (rows || []).some(rule => !!rule?.lhsColumnId && !currentColumnIds.has(rule.lhsColumnId));
    const staleIds = [];
    Object.keys(columnVisualProps).forEach(ownId => {
        const rows = columnVisualProps[ownId]?.conditionalFormatting?.rows;
        if (rows && rows.length > 0 && hasStaleLhs(rows)) {
            staleIds.push(ownId);
        }
    });
    if (staleIds.length === 0) {
        return customVisualProps;
    }
    const result = _.cloneDeep(customVisualProps);
    staleIds.forEach(ownId => {
        const legacyRows = legacyByCurrentId[ownId];
        result.columnVisualProps[ownId].conditionalFormatting =
            legacyRows && legacyRows.length > 0
                ? { rows: legacyRows }
                :
                    { rows: [] };
    });
    return result;
};
export const buildCustomVisualProps = ({ isChartSettingsV2Enabled, visualPropEditorDefinition, existingCustomVisualProps, persistedVisualPropKeys, overrideColumnProperties, legacyColumnProperties, isCustomChart = false, chartColumns, }) => {
    const defaultVisualPropsFromEditorDefinition = isChartSettingsV2Enabled
        ? generateCustomVisualProps(visualPropEditorDefinition)
        : generateVisPropWithColumnSettings(visualPropEditorDefinition);
    let result = _.isString(existingCustomVisualProps)
        ? existingCustomVisualProps
        : _.merge({}, defaultVisualPropsFromEditorDefinition, existingCustomVisualProps);
    if (!_.isString(result)) {
        if (isChartSettingsV2Enabled) {
            result = sanitizeCustomVisualPropsV2(result, visualPropEditorDefinition, persistedVisualPropKeys, isCustomChart);
        }
        else {
            result = sanitizeCustomVisualProps(result, visualPropEditorDefinition, persistedVisualPropKeys);
        }
        if (isChartSettingsV2Enabled && legacyColumnProperties?.length) {
            result = applyLegacyConditionalFormatsFallback(result, legacyColumnProperties);
        }
        if (isChartSettingsV2Enabled && chartColumns?.length) {
            result = replaceStaleCFRulesWithLegacy(result, legacyColumnProperties || [], chartColumns);
        }
        if (overrideColumnProperties?.length) {
            const overrideCFs = getConditionalFormatsFromOverrideColumnProperties(overrideColumnProperties);
            if (Object.keys(overrideCFs).length > 0) {
                result = updateCustomVisualPropsWithAllConditionalFormats(result, overrideCFs);
            }
        }
    }
    return result;
};
export const applyLegacyConditionalFormatsFallback = (customVisualProps, columnProperties) => {
    const legacyCFs = getAllConditionalFormattingsFromVizProp(columnProperties);
    const missing = {};
    Object.entries(legacyCFs).forEach(([columnId, rows]) => {
        const hasCFEntry = customVisualProps?.columnVisualProps?.[columnId]
            ?.conditionalFormatting !== undefined;
        if (!hasCFEntry) {
            missing[columnId] = rows;
        }
    });
    if (Object.keys(missing).length === 0) {
        return customVisualProps;
    }
    return updateCustomVisualPropsWithAllConditionalFormats(customVisualProps, missing);
};
//# sourceMappingURL=custom-visual-props.js.map